module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71e144f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modifiers/setting-col.vue
// module id = 112
// module chunks = 2